<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-tabs
        >
          <v-tab>
            Dienstkleidung
          </v-tab>
          <v-tab-item>
            <ShopOrder></ShopOrder>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ShopOrder from "../../components/shop/ShopOrder.vue";

export default {
  name: "PublicLogsticView",
  components: { ShopOrder },
  data: () => ({

  }),
  methods: {

  },
  mounted() {
    if (this.$store.state.shop.products === null) {
      this.$store.dispatch("update", { "context": "/shop/products"})
    }
  }
};
</script>

<style scoped>

</style>
